<template>
  <nav :class="{'is-scroll': isScroll, 'is-active': isActive}">
    <div class="nav-bar">
      <div>
        <a :style="{visibility: $route.meta.index === 1 ? 'visible' : 'hidden'}" class="back-button" @click.prevent="() => {$router.go(-1); isActive = false;}" href="#"><i></i>{{$store.state.translations.retour}}</a>
      </div>
      <div class="nav-bar-logo" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <router-link to="/"><img src="/images/logo.png" alt="logo" height="30" style="display: block;" /></router-link>
      </div>
      <div class="row items-center">
        <span class="lang-selector">
          <a :href="$router.resolve({name: $route.name, params: {...$route.params, lang: null}}).href" :class="{selected: $route.params.lang === 'fr' || !$route.params.lang}">FR</a>
          |
          <a :href="$router.resolve({name: $route.name, params: {...$route.params, lang: 'en'}}).href" :class="{selected: $route.params.lang === 'en'}">EN</a>
        </span>
        <button class="hamburger hamburger--slider" type="button" :class="{'is-active': isActive}" @click="isActive = !isActive">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
        </button>
      </div>
    </div>
    <ul>
      <li><router-link :to="{name: 'expertise'}" @click.native="isActive = false">{{$store.state.translations.menu_agence}}</router-link></li>
      <li><router-link :to="{name: 'portfolio'}" @click.native="isActive = false">{{$store.state.translations.menu_expertises}}</router-link></li>
      <li><router-link :to="{name: 'rgpd'}" @click.native="isActive = false">{{$store.state.translations.menu_traitement_de_la_reglementation_rgpd}}</router-link></li>
      <li><router-link :to="{name: 'conditions-generales'}" @click.native="isActive = false">{{$store.state.translations.menu_conditions_generales}}</router-link></li>
      <li><router-link :to="{name: 'mentions-legales'}" @click.native="isActive = false">{{$store.state.translations.menu_mentions_legales}}</router-link></li>
    </ul>
  </nav>
</template>

<style scoped lang="stylus">
$text-color = white
$menu-background-color = #1c1b1f

@import '../css/variables'
@import '../css/hamburgers/hamburgers'

$header-height = 70px
$items-color = #767678
$items-hover-color = white
$accent-color = red
$silver-color = silver

nav
  .nav-bar
    display flex
    justify-content space-between
    align-items center
    height $header-height
    @media mobile
      height 50px
    position fixed
    left 0
    right 0
    top 0
    background-color transparent
    z-index 10
    @media mobile-up
      border-bottom $items-color 1px solid
    transition 0.3s border-bottom-color, 0.3s background-color, 0.3s height
    @media tablet-up
      padding-right 30px
  &.is-scroll:not(.is-active)
    > .nav-bar
      border-bottom-color transparent
      background-color rgba(0, 0, 0, 0.8)
      height 50px
      > .nav-bar-logo
        @media mobile-up
          opacity 1

  .nav-bar-logo
    opacity 0
    transition 0.3s opacity

  &.is-active > ul
    transform none

  > ul
    display flex
    flex-direction column
    position fixed
    z-index 9
    bottom 0
    right 0
    left 0
    top 0
    list-style none
    padding 10px 30px
    padding-top $header-height + 10px
    margin 0
    background-color $menu-background-color
    overflow auto
    transform translate(100%, 0)
    transition transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1)
    li
      padding 10px 0
      display block
      a
        text-decoration none
        color $items-color
        transition color 0.4s
        text-transform uppercase
        font-size 30px
        @media mobile
          font-size 24px
        font-weight bold
        &:hover
          color $items-hover-color

.back-button
  text-transform uppercase
  padding-left 30px
  transition 0.3s all
  &:hover
    color $silver-color
    i
      border-color $silver-color
  i
    border solid white
    border-width 0 2px 2px 0
    display inline-block
    padding 7px
    transform rotate(135deg)
    vertical-align -2px
    transition 0.3s border-color

.lang-selector
  margin-top 5px
  margin-right 10px
  &, a
    color $silver-color
  a:hover, a.selected
    color white
</style>

<script>
export default {
  data () {
    return {
      isScroll: false,
      isActive: false
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      this.isScroll = window.scrollY > 0;
    });
  }
}
</script>